interface EmptyCaseWithTicketImageProps {
  title: string;
  className?: string;
}

const EmptyCaseWithTicketImage = ({ title, className }: EmptyCaseWithTicketImageProps) => {
  return (
    <div className={`w-full py-[40px] flex flex-col items-center gap-[24px] ${className}`}>
      <img
        src="/assets/bettie/empty_ticket_image.png"
        alt="empty case"
        className="w-[108px] h-[68px]"
      />
      <p className="text-[17px] font-bold text-text-main-lv2 leading-[20px]">{title}</p>
    </div>
  );
};

export default EmptyCaseWithTicketImage;
